import { useMutation } from '@tanstack/react-query'
import stratifyFarm, {
  type StratifyFarmParams,
} from '../../services/ruutsApi/stratification/stratifyFarm'
import vectorizeGeoraster, {
  type VectorizeGeorasterParams,
} from '../../services/ruutsApi/stratification/vectorize'

// Both jobs are minute-long science runs sent without a request timeout, so a retry would
// duplicate work already running server-side. The consumers wrap them in processLoading, whose
// dialog is the error surface — the global snackbar would be a second, redundant report.
const STRATIFICATION_JOB_OPTIONS = {
  retry: false,
  meta: { suppressGlobalError: true },
} as const

export const useVectorizeGeoraster = () =>
  useMutation({
    mutationFn: (params: VectorizeGeorasterParams) => vectorizeGeoraster(params),
    ...STRATIFICATION_JOB_OPTIONS,
  })

export const useStratifyFarm = () =>
  useMutation({
    mutationFn: (params: StratifyFarmParams) => stratifyFarm(params),
    ...STRATIFICATION_JOB_OPTIONS,
  })
